import axios from '../http'

function query(data) {
    return axios.post('/basedata/coach/query', data);
}


function get(id) {
    return axios.get('/basedata/coach/get?id=' + id);
}


export default {
    query,
    get
}